import { debounce, fromEvent, interval } from 'rxjs';
import { readCookie, createCookieByMins } from 'modules/cookieManager';

/**
 * @public
 * initUserInteractions: init the interactions between user and login cookie,
 * to notice when the interaction with the site is lost.
 * In a certain time, check the value of @see sessionAliveElement, if that number of minuts already happen and
 * the user don't interact the user need to be log out, for this reason we need to check the cookie IsUserLoggedIn
 */
const documentClicks$ = fromEvent(document, 'click')
.pipe(
    debounce(() => interval(3000))
);
const sessionAliveElement = document.querySelector('[data-session-alive-minutes]');
const sessionAliveMin = (sessionAliveElement && sessionAliveElement.value) || 10; 

const updateSession = {
    next: () => {
        const isUserLoggedIn = readCookie('IsUserLoggedIn', true);
        if (isUserLoggedIn === 'True') {
            createCookieByMins('IsUserLoggedIn', 'True', sessionAliveMin, true);
        }
    }
};

documentClicks$.subscribe(updateSession);